/**
 * Handles validation for all `StorePresentation` fields
 */
import { z } from 'zod';
import { BUTTON_LAYOUTS } from '@/types/store';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

export const storePresentationSchema = z.object({
    title: z.string().min(1, 'Title is required'),
    tagline: z.string(),
    text: z.string().min(1, 'Button text is required'),
    image: z.string().min(1, 'Image is required'),
    layout: z.nativeEnum(BUTTON_LAYOUTS),
    bottomTitle: z.string(),
    submitTitle: z.string(),
    topBannerText: z.string(),
});

export type StorePresentationFormData = z.infer<typeof storePresentationSchema>;
export type StoreSectionValidation = ReturnType<typeof useForm<StorePresentationFormData>>;

export const useStoreSectionValidation = (): StoreSectionValidation => {
    return useForm<StorePresentationFormData>({
        resolver: zodResolver(storePresentationSchema),
        defaultValues: {
            title: '',
            tagline: '',
            text: '',
            image: '',
            layout: undefined,
            bottomTitle: '',
            submitTitle: '',
            topBannerText: '',
        },
        mode: 'onChange',
    });
};
